import { Component } from '@angular/core'
import { SwUpdate } from '@angular/service-worker'
import { MegaSeoService } from '@megaphone/seo'
import { CookiesService } from '@megaphone/services'
import { MegaStatusService } from '@megaphone/status'
import { isIFrameLoaded } from '@models/core.const'
import { filter } from 'rxjs'
import { register } from 'swiper/element/bundle'
import { environment } from '../environments/environment'

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  constructor(
    _megaSeoService: MegaSeoService,
    _cookiesService: CookiesService,
    private _megaStatusService: MegaStatusService,
    private _sWUpdates: SwUpdate,
  ) {
    _megaSeoService.init({
      title: 'Megaphone Cloud',
      url: 'https://megaphone.info',
      siteName: 'Megaphone Cloud',
      image: 'https://assets.megaphone.info/images/megaphone/shared-link-logo-dark.png',
    })

    this._doSubscription()

    register()
    this._injectMegaphoneWidgets()
  }

  private _injectMegaphoneWidgets() {
    const envPath = environment.production ? 'production' : 'staging'
    const widgets = ['news', 'events', 'bookings']

    widgets.forEach((widget) => {
      // Inject styles
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = `https://widgets.megaphone.info/${envPath}/${widget}/styles.css`
      document.head.appendChild(link)

      // Inject polyfills
      const scriptPoly = document.createElement('script')
      scriptPoly.type = 'module'
      scriptPoly.src = `https://widgets.megaphone.info/${envPath}/${widget}/polyfills.js`
      document.body.appendChild(scriptPoly)

      // Inject main
      const scriptMain = document.createElement('script')
      scriptMain.type = 'module'
      scriptMain.src = `https://widgets.megaphone.info/${envPath}/${widget}/main.js`
      document.body.appendChild(scriptMain)
    })
  }

  private _doSubscription() {
    this._sWUpdates.unrecoverable.subscribe((_) => {
      location.reload()
    })

    this._megaStatusService.apiServerDown$
      .pipe(filter((event) => (event ? true : false)))
      .subscribe(() => {
        window.open('https://megaphone.info/under-construction/cloud', '_self')
      })

    if (isIFrameLoaded()) {
      document.body.classList.add('stripped')
      // window.addEventListener('message', (event) => this._receiveMessage(event), false)
    }
  }

  // Not working because of different origine
  // private _receiveMessage(event: MessageEvent) {
  //   const data: IframeMessage = event.data

  //   switch (data.type) {
  //     case 'mode': {
  //       document.body.classList.add(data.value)
  //       break
  //     }
  //   }
  // }
}
